import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IMyDpOptions, IMyInputFieldChanged, IMyInputFocusBlur } from 'mydatepicker';
import * as moment from 'moment';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-custom-patient-registration',
    templateUrl: './custom-patient-registration.component.html',
    styleUrls: ['./custom-patient-registration.component.scss']
})
export class CustomPatientRegistrationComponent implements OnInit {

    constructor(
        public translate: TranslateService,
        public fb: FormBuilder
    ) {
    }

    @Input() clinicId;
    @Input() errorMessage;
    @Input() errorData;
    @Input() languages;
    @Input() form;
    @Input() formSubmitted;
    @Input() languageId;
    @Input() headerText;
    @Input() clinicName;
    @Input() displayForms;
    @Output() submitForm = new EventEmitter<any>();
    dpkBirthdayOptions: IMyDpOptions = {
        dateFormat: 'dd.mm.yyyy',
        showTodayBtn: false,
        componentDisabled: false,
        disableSince: {
            year: null,
            month: null,
            day: null
        }
    };
    dateFormat = 'DD.MM.YYYY';
    validateCssBirthday: string = 'form-unfocused';
    isValidBirthday: boolean = true;
    genders = [
        {
            name : 'Male',
            value : 1
        },
        {
            name : 'Female',
            value : 2
        },
        {
            name : 'Gender X',
            value : 3
        }
    ];
    helpUrl = {};
    linkUrl = {
        concordia : {
            de_CH : 'https://www.klenico.com/legal/datenschutzerklaerung-mhc',
            en_GB : 'https://www.klenico.com/legal/datenschutzerklaerung-mhc'
        },
        sanitas : {
            de_CH : 'https://corporate.klenico.com/wp-content/uploads/2022/08/Datenschutzbestimmungen_Mentale_Gesundheitsanalyse_220617.pdf',
            en_GB : 'https://corporate.klenico.com/wp-content/uploads/2022/09/Privacy-Policy-Klenico-Mental-Health-Check-2022.pdf'
        }
    }
    clinic = {
        sanitas : 'Sanitas',
        concordia: 'Concordia'
    }

    ngOnInit(): void {
        this.form.controls['language_id'].setValue(this.languageId);
        if (this.clinicName === this.clinic.concordia) {
            this.form.controls['birthday'].setValidators([Validators.required]);
            this.initBirthdayCalendarSettings();
            this.clinicName = this.clinicName.toUpperCase();
        }
        this.helpUrl = this.linkUrl[this.clinicName.toLowerCase()];

        this.form.valueChanges.subscribe((field) => {
            if (field.email !== '' || field.confirm_email !== '') {
                this.handleConfirmData('confirm_email', field.email, field.confirm_email);
            }

            if (field.password !== '' || field.confirm_password !== '') {
                this.handleConfirmData('confirm_password', field.password, field.confirm_password);
            }
        });
    }

    submit(formValue, formValid) {
        let formattedBirthday = moment();
        if (formValue.birthday) {
            if (formValue.birthday.date) {
                formattedBirthday = moment({
                    year: formValue.birthday.date.year,
                    month: formValue.birthday.date.month - 1,
                    day: formValue.birthday.date.day,
                });
                formValue.birthday = formattedBirthday.format(this.dateFormat);
            }
        } else {
            formValue.birthday = '';
            this.validateCssBirthday = 'form-errored';
        }
        this.submitForm.emit({
            value: formValue,
            valid: formValid
        });
    }

    /**
     * Set default value for due date
     */
    initBirthdayCalendarSettings(): void {
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() + 1);

        this.dpkBirthdayOptions.disableSince.year = +yesterday.getFullYear();
        this.dpkBirthdayOptions.disableSince.month = +yesterday.getMonth() + 1;
        this.dpkBirthdayOptions.disableSince.day = +yesterday.getDate();
    }

    onBirthdayInputChanged(event: IMyInputFieldChanged) {
        this.isValidBirthday = event.valid;
    }

    /**
     * Handle focus in and focus out input
     * @param {IMyInputFocusBlur} event
     */
    onBirthdayFocusBlur(event: IMyInputFocusBlur): void {
        if (event.reason == 2 && !this.isValidBirthday) {
            this.validateCssBirthday = 'form-errored';
        } else if (event.reason == 2) {
            this.validateCssBirthday = 'form-unfocused';
        } else {
            this.validateCssBirthday = 'form-focused mat-focused';
        }
    }

    handleConfirmData(field, data, confirmData ) {
        if (data !== confirmData) {
            this.form.controls[field].setErrors({ mismatch: true });
        } else if (confirmData === '') {
            this.form.controls[field].setErrors({ required: true });
        } else {
            this.form.controls[field].setErrors(null);
        }
    }

}
